import { FC, forwardRef, ReactNode } from 'react';

import {
  Dialog,
  DialogContent,
  DialogProps,
  IconButton,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import classes from './Modal.module.scss';

export type ModalProps = DialogProps & {
  title: string;
  actions: ReactNode;
};

export const Modal = forwardRef<HTMLDivElement, ModalProps>(function Inner(
  { children, actions, title, onClose, ...dialogProps },
  ref,
) {
  return (
    <Dialog {...dialogProps}>
      <DialogContent fullscreen>
        <div className={classes.container} ref={ref}>
          <div className={classes.header}>
            <div className={classes.back}>
              <Typography variant='h5' ellipsis>
                {title}
              </Typography>
              <IconButton
                size='large'
                iconName={Icons.Close}
                onClick={onClose}
              />
            </div>
          </div>
          <div className={classes.body}>{children}</div>
          {actions && <div className={classes.footer}>{actions}</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
});
